(function() {
  $('.logo-list-slider__top').flickity({
    sync: '.logo-list-slider__thumb',
    pageDots: false,
    autoPlay: 5000,
    pauseAutoPlayOnHover: true,
    wrapAround: true,
    initialIndex: 2
  });
  // 2nd carousel, navigation
  $('.logo-list-slider__thumb').flickity({	
    pageDots: false,
    groupCells: 1,
    fullscreen: true,
    prevNextButtons: false,
    wrapAround: true,
    initialIndex: 2
  });
  $(".video-block.lazyload").each(function() {
    $(this).attr('src', $(this).attr("data-src"));
  });
})();